/* Desserter utan gränser — custom interactions v8 */
(function () {
  "use strict";

  /* ── Scroll reveal ─────────────────────────────── */
  const revEls = document.querySelectorAll(".rev");
  if ("IntersectionObserver" in window && revEls.length) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("v"); io.unobserve(e.target); } }),
      { threshold: 0.12, rootMargin: "0px 0px -30px 0px" }
    );
    revEls.forEach((el) => io.observe(el));
  }

  /* ── Logo injection ─────────────────────────────── */
  const logoUrl = document.body.dataset.logoUrl;

  function buildLogo() {
    const logoEl =
      document.querySelector('.header__logo-link') ||
      document.querySelector('.header__heading-link') ||
      document.querySelector('header-component a[href="/"]') ||
      document.querySelector('header-component a[href*="/"]');

    if (!logoEl || logoEl.querySelector('.dug-logo-wrap')) return false;

    logoEl.innerHTML = '';
    logoEl.removeAttribute('style');
    logoEl.style.cssText = 'display:flex;align-items:center;gap:.65rem;text-decoration:none;';

    if (logoUrl) {
      const img = document.createElement('img');
      img.src = logoUrl;
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.style.cssText = 'height:34px;width:34px;flex-shrink:0;object-fit:contain;';
      img.className = 'dug-logo-img';
      logoEl.appendChild(img);
    }

    const txt = document.createElement('span');
    txt.className = 'dug-logo-text';
    txt.style.cssText = 'display:flex;flex-direction:column;line-height:1.1;gap:.1rem;';
    txt.innerHTML =
      '<span class="dug-logo-main" style="font-family:CopperplateGothic,Copperplate,serif;font-style:italic;font-weight:400;font-size:1.05rem;color:#EDE4CC;letter-spacing:.01em;">Desserter</span>' +
      '<span class="dug-logo-sub" style="font-family:CopperplateGothic,Copperplate,serif;font-size:.5rem;font-weight:400;color:rgba(237,228,204,.5);letter-spacing:.25em;text-transform:uppercase;">utan gränser</span>';
    logoEl.appendChild(txt);

    const wrap = document.createElement('span');
    wrap.className = 'dug-logo-wrap';
    while (logoEl.firstChild) wrap.appendChild(logoEl.firstChild);
    logoEl.appendChild(wrap);

    return true;
  }

  function tryInjectLogo(attempts) {
    if (buildLogo()) return;
    if (attempts > 0) requestAnimationFrame(() => tryInjectLogo(attempts - 1));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => tryInjectLogo(20));
  } else {
    tryInjectLogo(20);
  }

  const headerObs = new MutationObserver(() => {
    if (buildLogo()) headerObs.disconnect();
  });
  headerObs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(() => headerObs.disconnect(), 5000);

  /* ── Frosted header on scroll ───────────────────── */
  const onScroll = () => {
    const scrolled = window.scrollY > 10;
    document.documentElement.classList.toggle("dug-scrolled", scrolled);
    const hc = document.querySelector("header-component");
    if (hc) hc.toggleAttribute("data-scrolled", scrolled);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ── Nav ─────────────────────────────────────────── */
  var navOverlay = null, navBd = null, navIsOpen = false;

  function getNavLinks() {
    var el = document.getElementById('dug-nav-data');
    if (!el) return [];
    try {
      var raw = JSON.parse(el.textContent);
      return (raw || []).map(function (item) {
        return {
          text: item.t,
          href: item.u || null,
          children: (item.c || []).map(function (c) {
            return { text: c.t, href: c.u || '/' };
          })
        };
      });
    } catch (e) { return []; }
  }

  function openNav() {
    if (navIsOpen || !navOverlay) return;
    navIsOpen = true;
    navOverlay.classList.add('is-open');
    navOverlay.setAttribute('aria-hidden', 'false');
    if (navBd) navBd.classList.add('is-open');
    document.documentElement.classList.add('dug-nav-open');
    var closeBtn = navOverlay.querySelector('.dug-mnav__close');
    if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeNav() {
    if (!navIsOpen || !navOverlay) return;
    navIsOpen = false;
    navOverlay.classList.remove('is-open');
    navOverlay.setAttribute('aria-hidden', 'true');
    if (navBd) navBd.classList.remove('is-open');
    document.documentElement.classList.remove('dug-nav-open');
  }

  /* Desktop nav — appended to header-component, centered via position:absolute in CSS */
  function buildDesktopNav(links) {
    if (document.getElementById('dug-dnav')) return true;
    var container =
      document.querySelector('header-component') ||
      document.querySelector('.header-section') ||
      document.querySelector('.header__row--top');
    if (!container) return false;

    var nav = document.createElement('nav');
    nav.id = 'dug-dnav';
    nav.setAttribute('aria-label', 'Huvudmeny');

    links.forEach(function (item) {
      var wrap = document.createElement('div');
      wrap.className = 'dug-dnav__item' + (item.children.length ? ' has-drop' : '');

      if (item.children.length) {
        wrap.innerHTML =
          '<button class="dug-dnav__link" type="button">' +
            item.text +
            '<svg class="dug-dnav__arr" width="8" height="5" viewBox="0 0 8 5" fill="none">' +
              '<path d="M1 1.5l3 2.5 3-2.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
            '</svg>' +
          '</button>' +
          '<div class="dug-dnav__drop">' +
            item.children.map(function (c) {
              return '<a class="dug-dnav__sub" href="' + c.href + '" style="font-size:.78rem;font-family:\'CopperplateGothic\',Copperplate,serif;letter-spacing:.1em;text-transform:uppercase;">' + c.text + '</a>';
            }).join('') +
          '</div>';
      } else {
        wrap.innerHTML =
          '<a class="dug-dnav__link" href="' + (item.href || '/') + '">' + item.text + '</a>';
      }

      nav.appendChild(wrap);
    });

    container.appendChild(nav);

    /* Force identical font size on all nav elements after DOM insertion */
    nav.querySelectorAll('.dug-dnav__link, .dug-dnav__sub').forEach(function (el) {
      el.style.setProperty('font-size', '12px', 'important');
      el.style.setProperty('font-family', "'CopperplateGothic', Copperplate, serif", 'important');
      el.style.setProperty('letter-spacing', '.12em', 'important');
      el.style.setProperty('text-transform', 'uppercase', 'important');
    });

    return true;
  }

  /* Mobile overlay — full screen slide-in */
  function buildMobileOverlay(links) {
    if (document.getElementById('dug-mnav')) return;
    if (!links || !links.length) return;

    navOverlay = document.createElement('div');
    navOverlay.id = 'dug-mnav';
    navOverlay.setAttribute('role', 'dialog');
    navOverlay.setAttribute('aria-modal', 'true');
    navOverlay.setAttribute('aria-label', 'Meny');
    navOverlay.setAttribute('aria-hidden', 'true');

    var rows = links.map(function (item) {
      var hasKids = item.children.length > 0;
      return (
        '<li class="dug-mnav__item">' +
        (hasKids
          ? '<button class="dug-mnav__row" type="button" aria-expanded="false">' +
              '<span class="dug-mnav__label">' + item.text + '</span>' +
              '<span class="dug-mnav__icon" aria-hidden="true">+</span>' +
            '</button>' +
            '<ul class="dug-mnav__sub" role="list">' +
            item.children.map(function (c) {
              return '<li><a class="dug-mnav__sublink" href="' + c.href + '">' + c.text + '</a></li>';
            }).join('') +
            '</ul>'
          : '<a class="dug-mnav__row" href="' + (item.href || '/') + '">' +
              '<span class="dug-mnav__label">' + item.text + '</span>' +
            '</a>') +
        '</li>'
      );
    });

    navOverlay.innerHTML =
      '<div class="dug-mnav__header">' +
        '<span class="dug-mnav__brand">Desserter utan gränser</span>' +
        '<button class="dug-mnav__close" aria-label="Stäng meny">' +
          '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round">' +
            '<line x1="2" y1="2" x2="16" y2="16"/><line x1="16" y1="2" x2="2" y2="16"/>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<ul class="dug-mnav__list" role="list">' + rows.join('') + '</ul>';

    document.body.appendChild(navOverlay);

    navBd = document.createElement('div');
    navBd.id = 'dug-mnav-bd';
    document.body.appendChild(navBd);

    navOverlay.querySelector('.dug-mnav__close').addEventListener('click', closeNav);
    navBd.addEventListener('click', closeNav);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navIsOpen) closeNav();
    });

    navOverlay.querySelectorAll('.dug-mnav__item').forEach(function (item) {
      var btn = item.querySelector('button.dug-mnav__row');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        navOverlay.querySelectorAll('.dug-mnav__item.is-open').forEach(function (el) {
          el.classList.remove('is-open');
          var b = el.querySelector('button.dug-mnav__row');
          var ic = el.querySelector('.dug-mnav__icon');
          if (b) b.setAttribute('aria-expanded', 'false');
          if (ic) ic.textContent = '+';
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          var ic = btn.querySelector('.dug-mnav__icon');
          if (ic) ic.textContent = '−';
        }
      });
    });
  }

  /* Hamburger button — insert before header-drawer (reliable DOM anchor) */
  function injectHamburger() {
    if (document.getElementById('dug-hamburger')) return true;

    /* header-drawer is always in Horizon's DOM even when hidden via CSS */
    var anchor =
      document.querySelector('header-drawer') ||
      document.querySelector('#Details-menu-drawer-container') ||
      document.querySelector('.header__icon--summary');
    if (!anchor) return false;

    var btn = document.createElement('button');
    btn.id = 'dug-hamburger';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Öppna meny');
    btn.innerHTML =
      '<svg width="22" height="14" viewBox="0 0 22 14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round">' +
        '<line x1="0" y1="1" x2="22" y2="1"/>' +
        '<line x1="0" y1="7" x2="22" y2="7"/>' +
        '<line x1="0" y1="13" x2="22" y2="13"/>' +
      '</svg>';

    btn.addEventListener('click', function () {
      navIsOpen ? closeNav() : openNav();
    });

    anchor.parentElement.insertBefore(btn, anchor);
    return true;
  }

  function initNav() {
    var links = getNavLinks();
    if (!links.length) return;
    buildDesktopNav(links);
    buildMobileOverlay(links);
    if (!injectHamburger()) {
      var n = 0;
      var iv = setInterval(function () {
        n++;
        if (injectHamburger() || n > 40) clearInterval(iv);
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNav);
  } else {
    initNav();
  }
  window.addEventListener('load', function () { initNav(); });

})();
